import axios from 'axios'
import { createAxios } from '../req'

import req from '../req'

// const inst = axios.create()
// console.log('createAxios',createAxios)
// inst.defaults.baseURL = 'https://ecshopx2-ba.shopex123.com/openapi'
// const req =  createAxios(inst)
// 获取开发配置
export function getDeveloper (params) {
  return req.get('/developer', params)
}
// 保存开发配置
export function setDeveloper (params) {
  return req.post('/developer', params)
}

// 外部请求配置-获取配置详情接口
export function getExternalSetting (params) {
  return req.get('/setting/external', params)
}

// 企业微信配置-保存配置详情接口
export function setExternalSetting (params) {
  return req.post('/setting/external', params)
}
